import { ZfBadge } from '@zafire/react';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { useMemo } from 'react';
import { useClient } from '../../api';
import { useNotificationsForClient } from '../../api/notification-api';
import { useWealthPlanningNavigate } from '../../hooks/useWealthPlanningNavigate';

export const RoadmapNavLinkBadge: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const { partnerUuid } = useWealthPlanningNavigate();
    const { data: client } = useClient(partnerUuid);
    const { data: notifications } = useNotificationsForClient(client?.id);

    const { dueEvents, overdueEvents } = useMemo(() => notifications ?? { dueEvents: 0, overdueEvents: 0 }, [notifications]);

    return dueEvents + overdueEvents > 0 ? (
        <ZfBadge type="number" value={`${dueEvents + overdueEvents}`} color="default" size="large" max={99}>
            {children}
        </ZfBadge>
    ) : (
        <>{children}</>
    );
};
